export default "__VITE_ASSET__HXAGXoEF__"